import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { initDriverMessaging } from '../services/notifications';

export default function NotificationPrompt({ uid, t }) {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(() => localStorage.getItem('mt_driver_push_ok') === '1');

  if (done || !uid) return null;

  const enable = async () => {
    setBusy(true);
    try {
      const token = await initDriverMessaging(uid, { request: true });
      if (token) {
        localStorage.setItem('mt_driver_push_ok', '1');
        setDone(true);
        toast.success(t('push.enabled'));
      } else {
        toast.error(t('push.denied'));
      }
    } catch {
      toast.error(t('push.denied'));
    } finally {
      setBusy(false);
    }
  };

  const later = () => {
    localStorage.setItem('mt_driver_push_later', String(Date.now()));
    setDone(true);
  };

  return (
    <div className="notif-prompt notif-prompt--compact">
      <div className="notif-prompt-copy">
        <strong>{t('push.promptTitle')}</strong>
        <p className="text-muted">{t('push.promptBody')}</p>
      </div>
      <div className="notif-prompt-actions">
        <button type="button" className="btn btn-ghost btn-sm" onClick={later}>
          {t('push.later')}
        </button>
        <button type="button" className="btn btn-green btn-sm" disabled={busy} onClick={enable}>
          {t('push.enable')}
        </button>
      </div>
    </div>
  );
}
